import React from "react";

import Button from "@material-ui/core/Button";

import ListingItem from "../../LisingItem";
import { isApproved, isRejected } from "./helper";
import { applicationConnector } from "../../../../../services/applications/connector";
import { dateTimeFormater } from "../../../../../utilities/formaters";

const ShowContentBasedOnDecision = ({
  offerWithDecision,
  rejectCreditOffer,
  approveCreditOffer,
}) => {
  const isAutomaticDecision = offerWithDecision.DecisionByPerson == null;
  const automaticOrManualDecisionMessage = isAutomaticDecision
    ? `Automatic decison on ${dateTimeFormater(offerWithDecision.DecisionTime)}`
    : `Offer decision by ${offerWithDecision.DecisionByPerson.Name} on ${dateTimeFormater(offerWithDecision.DecisionTime)}`;

  if (isApproved(offerWithDecision) || isRejected(offerWithDecision))
    return (
      <ListingItem
        primaryText={automaticOrManualDecisionMessage}
        secondaryText={isApproved(offerWithDecision) ? "Approved" : "Rejected"}
      />
    );

  if (!(isApproved(offerWithDecision) || isRejected(offerWithDecision)))
    return (
      <React.Fragment>
        <Button
          className="approveReject"
          variant="contained"
          color="primary"
          onClick={() => approveCreditOffer(offerWithDecision.Id)}
          style={{ marginLeft: "2px" }}
        >
          Approve
        </Button>
        <Button
          className="approveReject"
          variant="contained"
          color="primary"
          onClick={() => rejectCreditOffer(offerWithDecision.Id)}
          style={{ marginLeft: "2px" }}
        >
          Reject
        </Button>
      </React.Fragment>
    );
  return <React.Fragment />;
};

export default applicationConnector(ShowContentBasedOnDecision);
